/**
 * @file Decides whether an investment's profile needs the U.S. tax
 * withholding notice before it can submit.
 */
import { INVESTMENT_PROFILE_FIELD_MAP } from "@components/Domain";

import type { Investment, ProfileFields } from "../types";

type ProfileField = keyof typeof INVESTMENT_PROFILE_FIELD_MAP;

/**
 * Returns whether the investment's profile is a non-U.S.-citizen,
 * non-U.S.-person profile that needs the tax withholding notice.
 */
const shouldConfirmUsTaxWithholding = (investment: Investment): boolean => {
  const { profileType } = investment;

  if (!profileType) {
    return false;
  }

  const profileField = INVESTMENT_PROFILE_FIELD_MAP[profileType as ProfileField];

  if (!profileField) {
    return false;
  }

  const profile = investment[profileField] as ProfileFields | undefined;

  if (!profile) {
    return false;
  }

  const { isUsCitizen, isUsPerson } = profile;
  const isNotUsCitizen = isUsCitizen === false;
  const isNotUsPerson = isUsPerson === false;
  const shouldConfirm = isNotUsCitizen && isNotUsPerson;

  return shouldConfirm;
};

export default shouldConfirmUsTaxWithholding;
